<template>
  <Transition name="toast">
    <div
      v-if="isVisible"
      class="toast-message"
    >
      <AlertMessage
        :message="message"
        :title="title"
        :type="type"
      />
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

import AlertMessage from './AlertMessage.vue';

const props = withDefaults(
  defineProps<{
    type?: 'error' | 'success' | 'warning' | 'info';
    title?: string;
    message: string;
    duration?: number;
  }>(),
  {
    type: 'info',
    title: undefined,
    duration: 5000,
  },
);

const emit = defineEmits<{
  (e: 'unmount'): void;
}>();

const isVisible = ref(true);

onMounted(() => {
  setTimeout(() => {
    isVisible.value = false;
    emit('unmount');
  }, props.duration);
});
</script>

<style>
.toast-message {
  position: fixed;
  top: var(--gap-md);
  right: var(--gap-md);
  z-index: 1000;
  max-width: var(--size-toast-width);
}

.toast-enter-active,
.toast-leave-active {
  transition: var(--transition-default);
  will-change: opacity, transform;
}

.toast-enter-from {
  opacity: 0;
  transform: translateY(calc(-1 * var(--size-transform-sm)));
}

.toast-leave-to {
  opacity: 0;
  transform: translateY(calc(-1 * var(--size-transform-sm)));
}
</style>
